import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const DataBacklog = ({ isOpen, onClose, backlogData }) => {

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" style={{ paddingTop: "40px" }}>
      <ModalHeader toggle={onClose} style={{ paddingTop: "20px" }}>
        Data KK Tambahan dalam Satu Rumah
      </ModalHeader>
      <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
        {backlogData && backlogData.Backlogs && backlogData.Backlogs.length > 0 ? (
          <div>
            {/* Informasi Rumah */}
            <div className="mb-4 p-3 border rounded bg-light">
              <h6 className="text-primary">Informasi Rumah</h6>
              <div className="row">
                <div className="col-md-6">
                  <p><strong>Nama KK Utama:</strong> {backlogData.namaLengkapKK || '-'}</p>
                  <p><strong>Alamat:</strong> {backlogData.alamatRumah || '-'}</p>
                  <p><strong>Kecamatan:</strong> {backlogData.kecamatan || '-'}</p>
                </div>
                <div className="col-md-6">
                  <p><strong>Desa/Kelurahan:</strong> {backlogData.desaKelurahan || '-'}</p>
                  <p><strong>Jumlah KK:</strong> {backlogData.jumlahKK || '-'}</p>
                  <p><strong>Jumlah Penghuni:</strong> {backlogData.jumlahPenghuni || '-'} orang</p>
                </div>
              </div>
            </div>
            
            {/* KK Tambahan */}
            <h6 className="mb-3 text-danger">KK Tambahan yang Tinggal di Rumah yang Sama:</h6>
            {backlogData.Backlogs.map((backlog, index) => (
              <div key={backlog.id} className="mb-4 p-3 border rounded bg-light">
                <h6 className="text-primary">KK Tambahan {index + 1}</h6>
                <div className="row">
                  <div className="col-md-6">
                    <p><strong>Nama KK:</strong> {backlog.namaKK || '-'}</p>
                    <p><strong>Nomor KK:</strong> {backlog.nomorKK || '-'}</p>
                    <p><strong>Alamat:</strong> {backlog.alamat || '-'}</p>
                    <p><strong>Jumlah Anggota KK:</strong> {backlog.jumlahAnggotaKK || '-'} orang</p>
                  </div>
                  <div className="col-md-6">
                    <p><strong>Pekerjaan:</strong> {backlog.pekerjaan || '-'}</p>
                    <p><strong>Penghasilan:</strong> {backlog.penghasilan ? `Rp ${backlog.penghasilan.toLocaleString('id-ID')}` : '-'}</p>
                    <p><strong>Kepemilikan Tanah:</strong> {backlog.kepemilikanTanah || '-'}</p>
                    <p><strong>Usia Pernikahan:</strong> {backlog.usiaPernikahan || '-'} tahun</p>
                  </div>
                </div>
                <p><strong>Tanggal Input:</strong> {backlog.createdAt ? new Date(backlog.createdAt).toLocaleDateString('id-ID', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                }) : '-'}</p>
              </div>
            ))}

            {/* Summary */}
            <div className="mt-4 p-3 bg-info bg-opacity-10 border border-info rounded">
              <h6 className="text-info">Ringkasan:</h6>
              <p className="mb-1">• Total KK dalam rumah ini: <strong>{backlogData.jumlahKK}</strong></p>
              <p className="mb-1">• Total penghuni: <strong>{backlogData.jumlahPenghuni}</strong> orang</p>
              <p className="mb-0">• KK tambahan: <strong>{backlogData.Backlogs.length}</strong></p>
            </div>
          </div>
        ) : (
          <div className="text-center py-4">
            <div className="alert alert-info">
              <h6>Tidak ada data KK tambahan</h6>
              <p className="mb-0">Rumah ini hanya memiliki 1 KK atau belum memiliki data backlog KK tambahan.</p>
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>Tutup</Button>
      </ModalFooter>
    </Modal>
  );
};

export default DataBacklog;